import React from 'react';
import { Typography, TypographyVariant } from '@mui/material';

interface InlineTextProps {
  children: React.ReactNode;
  value?: {
    inlineText: TypographyVariant;
  };
}

const InlineText = ({ children, value }: InlineTextProps) => {  
    
  return (
    <>
    <Typography variant={value?.inlineText ?? 'body1'} component='span'>    
      {children}
    </Typography>
    </>
  );
};

export default InlineText;
